/* Eclipse Sample Sales — Mega menus desktop (Chantier 4)
 * Loaded by sections/header-inline-blocks.liquid.
 *
 * The mega menus are rendered INSIDE Kalles' native <details> element by
 * snippets/main-menu.liquid (Eclipse fork). Open/close is handled by the
 * <hdt-header-menu> web component and CSS hover. This script only:
 *   1. Lazy-activates live countdowns when a mega menu opens.
 *   2. Closes the mega menu on Escape key (defensive — Kalles may already do this).
 */

(function () {
  'use strict';

  var COUNTDOWN_TICK_MS = 1000;
  var observers = new WeakMap();

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function formatRemaining(ms) {
    if (ms < 0) ms = 0;
    var totalSec = Math.floor(ms / 1000);
    var d = Math.floor(totalSec / 86400);
    var h = Math.floor((totalSec % 86400) / 3600);
    var m = Math.floor((totalSec % 3600) / 60);
    var s = totalSec % 60;
    return { d: d, h: h, m: m, s: s };
  }

  function tickCountdown(node) {
    var endIso = node.getAttribute('data-mm-end');
    if (!endIso) return;
    var endMs = Date.parse(endIso);
    if (isNaN(endMs)) return;
    var remaining = formatRemaining(endMs - Date.now());

    var dEl = node.querySelector('[data-mm-d]');
    var hEl = node.querySelector('[data-mm-h]');
    var mEl = node.querySelector('[data-mm-m]');
    var sEl = node.querySelector('[data-mm-s]');

    if (dEl) dEl.textContent = pad(remaining.d);
    if (hEl) hEl.textContent = pad(remaining.h);
    if (mEl) mEl.textContent = pad(remaining.m);
    if (sEl) sEl.textContent = pad(remaining.s);
  }

  function activateCountdowns(panel) {
    if (panel._ecMegamenuTimer) return;
    var nodes = panel.querySelectorAll('[data-eclipse-megamenu-countdown]');
    if (!nodes.length) return;
    nodes.forEach(tickCountdown);
    panel._ecMegamenuTimer = setInterval(function () {
      nodes.forEach(tickCountdown);
    }, COUNTDOWN_TICK_MS);
  }

  function deactivateCountdowns(panel) {
    if (!panel._ecMegamenuTimer) return;
    clearInterval(panel._ecMegamenuTimer);
    panel._ecMegamenuTimer = null;
  }

  function watchPanel(panel) {
    if (observers.has(panel)) return;
    var details = panel.closest('details');
    if (!details) {
      activateCountdowns(panel);
      return;
    }
    var obs = new MutationObserver(function () {
      if (details.hasAttribute('open')) {
        activateCountdowns(panel);
      } else {
        deactivateCountdowns(panel);
      }
    });
    obs.observe(details, { attributes: true, attributeFilter: ['open'] });
    observers.set(panel, obs);

    if (details.hasAttribute('open')) activateCountdowns(panel);
  }

  // Toggle Kalles' .scrolled-past-header class on the header section when
  // an Eclipse mega menu opens, so the navbar adopts the same light state
  // it has at scroll. Restore the original state on close (don't remove
  // the class if the page is genuinely scrolled past the trigger point).
  function findHeader() {
    return document.querySelector(
      'header.shopify-section-header-sticky, ' +
      'header.shopify-section-group-header-group, ' +
      'header.shopify-section-header'
    );
  }

  // Lock page scroll while an Eclipse mega menu is open. We can't use
  // CSS overflow on <html> here: `hidden` makes the root a scroll
  // container and steals wheel events from the in-store row; `clip`
  // removes <html> as a scroll container and kills the Kalles
  // `position: sticky` header (the mega menu then anchors at document
  // top instead of viewport top, invisible when scrolled). Instead we
  // block wheel/touchmove on the document EXCEPT when the event
  // originates inside `.ec-megamenu--instore` (which scrolls itself).
  function syncBodyScrollLock() {
    var anyOpen = !!document.querySelector('details[not-need-calc][open]');
    document.documentElement.classList.toggle('ec-megamenu-open', anyOpen);
    document.body.classList.toggle('ec-megamenu-open', anyOpen);
  }

  function preventPageScroll(e) {
    if (!document.body.classList.contains('ec-megamenu-open')) return;
    // The in-store cities row has its own wheel handler that scrolls
    // horizontally — let those events through.
    if (e.target && e.target.closest && e.target.closest('.ec-megamenu--instore')) return;
    e.preventDefault();
  }

  function syncHeaderState() {
    var header = findHeader();
    if (!header) return;
    var anyOpen = !!document.querySelector('.ec-megamenu-wrap details[not-need-calc][open], details[not-need-calc][open]');
    if (anyOpen) {
      header.classList.add('scrolled-past-header');
      header.dataset.eclipseForcedScroll = '1';
    } else if (header.dataset.eclipseForcedScroll === '1') {
      // Only remove if WE added it; let Kalles' own scroll handler keep
      // it when the page is genuinely scrolled.
      var scrolled = (window.scrollY || window.pageYOffset || 0) > 50;
      if (!scrolled) {
        header.classList.remove('scrolled-past-header');
      }
      delete header.dataset.eclipseForcedScroll;
    }
  }

  // Shared timer so moving from one Eclipse trigger to another cancels
  // the pending fade-back instead of flickering transparent → white.
  var navFadeTimer = null;

  function watchHeaderToggle() {
    document.querySelectorAll('details[not-need-calc]').forEach(function (d) {
      new MutationObserver(function () {
        syncHeaderState();
        syncBodyScrollLock();
      }).observe(d, {
        attributes: true,
        attributeFilter: ['open']
      });

      var hdr = d.closest('hdt-header-menu') || d.parentElement;
      if (!hdr) return;

      // Cancel any pending fade-back when the user enters another
      // Eclipse trigger directly from a previous one.
      hdr.addEventListener('mouseenter', function () {
        if (navFadeTimer) {
          clearTimeout(navFadeTimer);
          navFadeTimer = null;
        }
      });

      // Kalles delays the actual close animation of <details>, so
      // schedule the fade-back to land at the same time as the mega
      // menu finishes collapsing (~280ms). Bail if the user re-enters
      // another trigger in the meantime (handled above).
      hdr.addEventListener('mouseleave', function () {
        var header = findHeader();
        if (!header) return;
        if (header.dataset.eclipseForcedScroll !== '1') return;
        var scrolled = (window.scrollY || window.pageYOffset || 0) > 50;
        if (scrolled) return; // Kalles owns the class while scrolled
        if (navFadeTimer) clearTimeout(navFadeTimer);
        navFadeTimer = setTimeout(function () {
          header.classList.remove('scrolled-past-header');
          delete header.dataset.eclipseForcedScroll;
          navFadeTimer = null;
        }, 280);
      });
    });
  }

  // Smooth-scroll for any Eclipse navbar / mega menu / footer / burger
  // link pointing at an in-page anchor. Anchors covered: #shop-online,
  // #in-store-events, and every city handle (any element with
  // `data-eclipse-city` set by the Chantier 2 sections).
  //
  // Why this exists: leaving a hash in the URL caused random jump-backs
  // on subsequent user scrolls (browser or Kalles' sticky-header re-
  // honoring the anchor). Using `scrollIntoView` also focuses the target
  // which produced layout shifts. So we (1) `window.scrollTo` with an
  // offset for the sticky header, (2) keep the URL hash-free, and (3)
  // dispatch a synthetic `hashchange` so `eclipse-city-tabs.js` can
  // activate the matching tab without writing the hash to the address bar.
  var SCROLL_HEADER_OFFSET_PX = 80;

  // Only intercept clicks that originate from Eclipse-rendered surfaces
  // (mega menus, burger sub-menus, footer cities) OR from the main-menu
  // <summary> elements in the navbar (which Kalles' <hdt-header-menu>
  // would otherwise navigate via `window.location.href = data-url` —
  // that's the path that triggers the jump-back). The slideshow CTA
  // <a href> is left untouched: Kalles + browser already handle it
  // correctly (Sam confirmed it works without our handler).
  function isEclipseScrollContext(target) {
    return !!target.closest(
      '.ec-megamenu-wrap, [data-eclipse-megamenu], .ec-burger-online, ' +
      '.ec-burger-instore, .ec-footer-cities, .hdt-footer-col-block, ' +
      'hdt-header-menu'
    );
  }

  function smoothScrollHandler(e) {
    var target = e.target.closest('a[href*="#"], summary[data-url*="#"]');
    if (!target) return;
    var url = target.getAttribute('href') || target.getAttribute('data-url') || '';
    if (!url) return;
    var hash = url.indexOf('#') >= 0 ? url.split('#').pop() : '';
    if (!hash) return;

    // Only intercept Eclipse-controlled surfaces — anything else (e.g.
    // the slideshow CTA) goes through native browser navigation.
    if (!isEclipseScrollContext(target)) return;

    var section = document.getElementById(hash);

    // Cross-page navigation: <summary> doesn't navigate natively (it just
    // toggles the <details>). If the section isn't on the current page,
    // navigate to the homepage with the anchor manually.
    if (!section) {
      e.preventDefault();
      e.stopPropagation();
      window.location.href = '/#' + hash;
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    // Strip any existing hash before animating — if the browser picks it
    // up later, it will re-jump on every scroll/resize.
    if (window.history && history.replaceState && window.location.hash) {
      history.replaceState(null, '', window.location.pathname + window.location.search);
    }

    var top = window.scrollY + section.getBoundingClientRect().top - SCROLL_HEADER_OFFSET_PX;
    window.scrollTo({ top: top, behavior: 'smooth' });

    // If the target is a city section, activate the matching tab via a
    // synthetic hashchange (without writing the hash to the URL).
    var isCity = !!document.querySelector('[data-eclipse-city="' + hash + '"]');
    if (isCity) {
      try {
        history.replaceState(null, '', window.location.pathname + window.location.search + '#' + hash);
        window.dispatchEvent(new Event('hashchange'));
      } catch (_) { /* noop */ }
      setTimeout(function () {
        if (window.history && history.replaceState) {
          history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      }, 0);
    }

    // Defer closing any open Eclipse mega menu until the scroll animation
    // has had a chance to start. Closing immediately can cause Kalles'
    // <details>/<summary> focus restore to fire BEFORE the smooth scroll
    // commits, which then snaps the page back to where the user was.
    setTimeout(function () {
      document.querySelectorAll('details[not-need-calc][open]').forEach(function (d) {
        d.removeAttribute('open');
      });
      syncHeaderState();
    }, 600);
  }

  function init() {
    // Prevent the browser from restoring the previous scroll position
    // when something updates the URL (replaceState, focus restore, etc.) —
    // the symptom was a hard jump back to the user's pre-click position
    // a moment after the smooth scroll landed.
    if ('scrollRestoration' in history) {
      try { history.scrollRestoration = 'manual'; } catch (_) { /* noop */ }
    }

    document.querySelectorAll('.ec-megamenu').forEach(watchPanel);
    watchHeaderToggle();

    // Page scroll lock: block wheel/touchmove on the document when a
    // mega menu is open, except inside the in-store row (handled below).
    document.addEventListener('wheel', preventPageScroll, { passive: false });
    document.addEventListener('touchmove', preventPageScroll, { passive: false });

    // Horizontal wheel/trackpad scroll on the In-Store cities row.
    // Same pattern as eclipse-city-tabs.js bindBigwordsDragAndWheel.
    document.querySelectorAll('.ec-megamenu--instore').forEach(function (wrap) {
      wrap.addEventListener('wheel', function (e) {
        var maxScroll = wrap.scrollWidth - wrap.clientWidth;
        if (maxScroll <= 0) return;
        var absX = Math.abs(e.deltaX);
        var absY = Math.abs(e.deltaY);
        var delta = absX > absY ? e.deltaX : e.deltaY;
        if (delta === 0) return;
        if (e.deltaMode === 1) delta *= 16;
        else if (e.deltaMode === 2) delta *= wrap.clientWidth;
        var atStart = wrap.scrollLeft <= 0 && delta < 0;
        var atEnd = wrap.scrollLeft >= maxScroll - 1 && delta > 0;
        if (atStart || atEnd) return;
        e.preventDefault();
        wrap.scrollLeft += delta;
      }, { passive: false });
    });

    // Minimal anchor handler for the navbar Eclipse triggers. The
    // <summary> in main-menu.liquid wraps "Shop Online" / "In-Store
    // Events" in a real <a class="ec-mm-anchor" href="/#X">. On click,
    // we stop the click reaching Kalles' <hdt-header-menu> (which
    // would otherwise either navigate via window.location.href or
    // toggle the <details>) and we drive the smooth scroll directly.
    function onAnchorClick(e) {
      // Cover both kinds of Eclipse links:
      //   1. Navbar mega-menu triggers: a.ec-mm-anchor (Shop Online,
      //      In-Store Events) — wrapped inside a Kalles <summary>.
      //   2. Any anchor pointing at "/#X" or "#X" that lives inside an
      //      Eclipse surface — mega menu rows, footer cities column,
      //      burger sub-menus.
      var a = e.target.closest(
        'a.ec-mm-anchor, ' +
        '.ec-megamenu-wrap a[href*="#"], ' +
        '[data-eclipse-megamenu] a[href*="#"], ' +
        '.ec-footer-cities a[href*="#"], ' +
        '.hdt-footer-col-block a[href*="#"], ' +
        '.ec-burger-online a[href*="#"], ' +
        '.ec-burger-instore a[href*="#"]'
      );
      if (!a) return;
      var href = a.getAttribute('href') || '';
      var hash = href.indexOf('#') >= 0 ? href.split('#').pop() : '';
      if (!hash) return;

      // City handle detection: city-tabs.liquid hides every non-active
      // city section so getElementById('<city>') returns an element
      // with no visible position. We need to (a) activate the city tab
      // and (b) scroll to the In-Store section wrapper, not to the
      // hidden anchor inside it.
      var isCity = !!document.querySelector('[data-eclipse-city="' + hash + '"]');
      var scrollTarget = isCity
        ? document.getElementById('in-store-events')
        : document.getElementById(hash);
      if (!scrollTarget) return; // cross-page: let the browser navigate

      e.preventDefault();
      e.stopPropagation();
      if (typeof e.stopImmediatePropagation === 'function') {
        e.stopImmediatePropagation();
      }

      // Close any open Eclipse mega menu so the panel doesn't cover
      // the scroll target.
      document.querySelectorAll('details[not-need-calc][open]').forEach(function (d) {
        d.removeAttribute('open');
      });

      // For cities: trigger a synthetic hashchange so eclipse-city-
      // tabs.js activates the matching tab. Briefly set the hash,
      // dispatch, then strip — keeps the URL clean (avoids the
      // browser's hash-jump on next user scroll).
      if (isCity) {
        try {
          history.replaceState(null, '', window.location.pathname + window.location.search + '#' + hash);
          window.dispatchEvent(new Event('hashchange'));
        } catch (_) { /* noop */ }
        setTimeout(function () {
          if (window.history && history.replaceState) {
            history.replaceState(null, '', window.location.pathname + window.location.search);
          }
        }, 0);
      }

      scrollTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    document.addEventListener('click', onAnchorClick, true);

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      document.querySelectorAll('.ec-megamenu').forEach(function (panel) {
        var details = panel.closest('details');
        if (details && details.hasAttribute('open')) {
          details.removeAttribute('open');
        }
      });
      syncHeaderState();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
